<template>
    <label class="rwl-checkbox" :for="id" :class="[hasDefaultSlot ? 'has-text' : '']">
        <p class="checkbox__text" v-if="hasDefaultSlot">
            <input
                    :id="id"
                    type="checkbox"
                    class="input"
                    v-on="$listeners"
                    v-bind="$attrs"
            />
            <span class="checkbox__select">
            <div class="checkbox__select-icon">
                <slot name="icon">
                <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 1L4.125 7.875L1 4.75" stroke="white" stroke-width="2" stroke-linecap="round"
                          stroke-linejoin="round"/>
                </svg>
                    </slot>
            </div>
        </span>
            <slot></slot>
        </p>
    </label>
</template>

<script>
    /**
     *
     */
    export default {
        name: "RwlCheckbox",
        status: "prototype",
        release: "1.0.0",
        props: {
            id: {
                type: String,
                default: null,
            }
        },
        computed: {
            hasDefaultSlot() {
                return !!this.$slots.default
            },
        },
    }
</script>

<style lang="scss">
</style>

<docs>
    ```jsx
    <div>
        <RwlCheckbox>
            Cras eros sem, faucibus eget tempus ac, mattis semper justo. Aliquam eu consequat nisi, quis mollis eros.
            Aliquam faucibus pretium nulla ac elementum.
        </RwlCheckbox>

        <RwlCheckbox></RwlCheckbox>
    </div>
    ```
</docs>
